<script>
import ProductDataService from "../services/ProductDataService";

export default {
	name: 'Home',
	props: {
		theme: String
	},
	components: {
	},
	data: () => ({
		stores: []
	}),
	methods: {
      track () {
        this.$gtag.pageview(this.$route);
        this.$gtag.query('set', 'user_properties', { 'app_version': this.$store.getters['core/appVersion'], 'app_name': 'shop-ouderraadloppem' });
		this.$gtag.set({'app_version' : this.$store.getters['core/appVersion'] });
		this.$gtag.event('app_version', {'value': this.$store.getters['core/appVersion'] });
      },
	},
	async created(){
		this.track();
		this.stores = await ProductDataService.getCategories();
	}
};
</script>

<template>
	<div class="container mx-auto px-4">
		<section
			class="flex sm:justify-between items-center sm:flex-row mt-12 sm:mt-10 mb-5 sm:mb-8"
		>
			<div class="w-full">
				<h1
					class="font-general-semibold text-3xl md:text-3xl xl:text-4xl text-center text-ternary-dark dark:text-primary-light uppercase"
				>
				Kies je winkel
				</h1>
			</div>
		</section>

		<!-- Active Stores Grid -->
		<section class="mt-8 mb-16 grid grid-cols-1 gap-y-12 sm:grid-cols-2 sm:gap-x-6 lg:grid-cols-2 xl:gap-x-8">
			<router-link
				v-for="store in stores"
				:key="store.id"
				:to="store.slug === 'koeken' ? '/koeken' : '/shop/' + store.slug"
				class="rounded-xl shadow-lg hover:shadow-xl cursor-pointer bg-secondary-light dark:bg-ternary-dark overflow-hidden transform transition duration-300 hover:scale-105"
			>
				<div class="relative h-72 w-full overflow-hidden" v-if="store.images && store.images.length > 0">
					<img :src="store.images[0].src" :alt="store.name" class="h-full w-full object-cover" />
					<div aria-hidden="true" class="absolute inset-x-0 bottom-0 h-36 bg-gradient-to-t from-black opacity-70" />
					<div class="absolute inset-x-0 bottom-0 p-4">
						<h3 class="text-3xl font-semibold text-white">{{ store.name }}</h3>
					</div>
				</div>
				<div v-else class="p-8 text-center flex items-center justify-center h-48">
					<h3 class="text-3xl font-semibold text-secondary-dark dark:text-ternary-light">{{ store.name }}</h3>
				</div>
			</router-link>
		</section>
	</div>
</template>